export default __webpack_public_path__ + "static/media/img-ln-2-big-mobile.c5570565.jpg";